import React, {useEffect, useState} from 'react'
import Slider from "react-slick";
// import React, { useState, useCallback, useEffect, useContext } from 'react'
import Input from '@mui/material/Input'
import { Select, MenuItem } from '@mui/material'
import { Link, useNavigate } from 'react-router-dom'
import ProgettoStandBy from './images/progetto-salvato.png'

const ProjectStandBy = props => {

  const { project, projectTypes, handleNext, sendCurrentHeaderData, products, sendUpdate, addProducts } = props
  const { titolo, descrizione, tiposito, projectType, localita, prodotti, addedProducts } = project


  const navigate = useNavigate();

  const slickSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3.25,
    slidesToScroll: 3,
    centerMode:false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.25,
          slidesToScroll: 2,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.25,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.25,
          slidesToScroll: 1
        }
      }
    ]
  };


  const manageProducts = (e) => {
    
    if (e.target.checked) {
      if (!prodotti.find(el => el?.id_prodotto === e.target.value)) {
        sendUpdate('prodotti', [
          ...prodotti,
          {
            id_prodotto: parseInt(e.target.value, 10)
          }
        ])
      }
    } else {
      sendUpdate(
        'prodotti',
        prodotti.filter(
          el => el?.id_prodotto !== parseInt(e.target.value, 10)
        )
      )
    }


  }


  const handleAddProducts = () => {
    sendUpdate(
      'addedProducts',
      [...addedProducts, ...prodotti.map((el)=>el.id_prodotto)]
    )
    addProducts();
  }


  const handleTheNext = () => {
    sendCurrentHeaderData({})
    handleNext()
  }
  useEffect(()=>{
    sendCurrentHeaderData({
        title:'Il tuo progetto è stato salvato!',
        description:(<>Per 24 ore il tuo progetto rimarrà nella <span className="gold">sala di attesa</span> e
            potrai vederlo solo tu per permetterti di aggiungere il template.
            Al termine  il progetto sarà pubblicato e saranno i nostri freelance
            a sceglierlo per te.</>),
        icon:ProgettoStandBy,
        iconTitle:''
      })
  }, [])

  return (
    <div className="col-11 mx-auto">
      { false ? (<>
      <h2 className="text-center">Dai una carica extra al tuo progetto</h2>
      <div className="row mt-3">
        
        <div className="col-12 text-center">

        <Slider {...slickSettings}>
          {products &&
            products.filter((el)=>!addedProducts.includes(el.id)).map(el => (
              <>
                <div className="item mt-5 px-2">
                    <input type="checkbox"
                      className="team-selection"
                      id={el.nome.replaceAll(" ", "")}
                      name={el.nome.replaceAll(" ", "")}
                      value={el.id}
                      checked={
                        prodotti.find(
                          ej =>
                            parseInt(ej?.id_prodotto, 10) ===
                            parseInt(el.id, 10)
                        ) || false
                      }
                      onChange={manageProducts}
                    />
                    <label htmlFor={el.nome.replaceAll(" ", "")}>
                      {el.immaginepath ? (
                        <>
                          <img alt={el.nome} src={el.immaginepath} />
                        </>
                      ) : null}
                      <h4>{el.nome}</h4>
                      <p>€ {el.costo.toFixed(2)}</p>
                    </label>
                  </div>
              </>
            ))}

          </Slider>

          {prodotti.length > 0 ? (<>

<button
  type="button"
  className="btn btn-lg btn-primary letter-spacing-1 swpier-next"
  alt=""
  onClick={handleAddProducts}
  
>
  Aggiungi prodotti selezionati
</button>
</>) : null}

<br />

          <button
            type="button"
            className="btn btn-lg btn-primary letter-spacing-1 swpier-next"
            alt=""
            onClick={() => handleTheNext()}
          >
            Seleziona il template
          </button>

        </div>
      </div>
      </>) : null}
          <div className="row mt-3">
            <div className="col-12 text-center">
              <button
                type="button"
                className="btn btn-lg btn-primary letter-spacing-1 swpier-next"
                alt=""
                onClick={() => handleTheNext()}
              >
                Seleziona il template
              </button>
            </div>
          </div>
    </div>
  )
}

export default ProjectStandBy
